{
    "countryListEnglish": [
        {
            "countryName": "Canada",
            "id": "Canada"
        },
        {
            "countryName": "USA",
            "id": "USA"
        },
        {
            "countryName": "Afghanistan",
            "id": "Afghanistan"
        },
        {
            "countryName": "Åland Islands",
            "id": "Åland Islands"
        },
        {
            "countryName": "Albania",
            "id": "Albania"
        },
        {
            "countryName": "Algeria",
            "id": "Algeria"
        },
        {
            "countryName": "American Samoa",
            "id": "American Samoa"
        },
        {
            "countryName": "Andorra",
            "id": "Andorra"
        },
        {
            "countryName": "Angola",
            "id": "Angola"
        },
        {
            "countryName": "Anguilla",
            "id": "Anguilla"
        },
        {
            "countryName": "Antarctica",
            "id": "Antarctica"
        },
        {
            "countryName": "Antigua and Barbuda",
            "id": "Antigua and Barbuda"
        },
        {
            "countryName": "Argentina",
            "id": "Argentina"
        },
        {
            "countryName": "Armenia",
            "id": "Armenia"
        },
        {
            "countryName": "Aruba",
            "id": "Aruba"
        },
        {
            "countryName": "Australia",
            "id": "Australia"
        },
        {
            "countryName": "Austria",
            "id": "Austria"
        },
        {
            "countryName": "Azerbaijan",
            "id": "Azerbaijan"
        },
        {
            "countryName": "Bahamas",
            "id": "The Bahamas"
        },
        {
            "countryName": "Bahrain",
            "id": "Bahrain"
        },
        {
            "countryName": "Bangladesh",
            "id": "Bangladesh"
        },
        {
            "countryName": "Barbados",
            "id": "Barbados"
        },
        {
            "countryName": "Belarus",
            "id": "Belarus"
        },
        {
            "countryName": "Belgium",
            "id": "Belgium"
        },
        {
            "countryName": "Belize",
            "id": "Belize"
        },
        {
            "countryName": "Benin",
            "id": "Benin"
        },
        {
            "countryName": "Bermuda",
            "id": "Bermuda"
        },
        {
            "countryName": "Bhutan",
            "id": "Bhutan"
        },
        {
            "countryName": "Bolivia",
            "id": "Bolivia"
        },
        {
            "countryName": "Bosnia and Herzegovina",
            "id": "Bosnia and Herzegovina"
        },
        {
            "countryName": "Botswana",
            "id": "Botswana"
        },
        {
            "countryName": "Bouvet Island",
            "id": "Bouvet Island"
        },
        {
            "countryName": "Brazil",
            "id": "Brazil"
        },
        {
            "countryName": "British Indian Ocean Territory",
            "id": "British Indian Ocean Territory"
        },
        {
            "countryName": "Brunei",
            "id": "Brunei"
        },
        {
            "countryName": "Bulgaria",
            "id": "Bulgaria"
        },
        {
            "countryName": "Burkina Faso",
            "id": "Burkina Faso"
        },
        {
            "countryName": "Burundi",
            "id": "Burundi"
        },
        {
            "countryName": "Cambodia",
            "id": "Cambodia"
        },
        {
            "countryName": "Cameroon",
            "id": "Cameroon"
        },
        {
            "countryName": "Cape Verde",
            "id": "Cape Verde"
        },
        {
            "countryName": "Cayman Islands",
            "id": "Cayman Islands"
        },
        {
            "countryName": "Central African Republic",
            "id": "Central African Republic"
        },
        {
            "countryName": "Chad",
            "id": "Chad"
        },
        {
            "countryName": "Chile",
            "id": "Chile"
        },
        {
            "countryName": "China",
            "id": "China"
        },
        {
            "countryName": "Christmas Island",
            "id": "Christmas Island"
        },
        {
            "countryName": "Cocos (Keeling) Islands",
            "id": "Cocos (Keeling) Islands"
        },
        {
            "countryName": "Colombia",
            "id": "Colombia"
        },
        {
            "countryName": "Comoros",
            "id": "Comoros"
        },
        {
            "countryName": "Congo",
            "id": "Democratic Republic of the Congo"
        },
        {
            "countryName": "Congo - Brazzaville",
            "id": "Republic of the Congo"
        },
        {
            "countryName": "Cook Islands",
            "id": "Cook Islands"
        },
        {
            "countryName": "Costa Rica",
            "id": "Costa Rica"
        },
        {
            "countryName": "Côte d’Ivoire",
            "id": "Côte d'Ivoire" 
        },
        {
            "countryName": "Croatia",
            "id": "Croatia"
        },
        {
            "countryName": "Cuba",
            "id": "Cuba"
        },
        {
            "countryName": "Cyprus",
            "id": "Cyprus"
        },
        {
            "countryName": "Czech Republic",
            "id": "Czechia"
        },
        {
            "countryName": "Denmark",
            "id": "Denmark"
        },
        {
            "countryName": "Djibouti",
            "id": "Djibouti"
        },
        {
            "countryName": "Dominica",
            "id": "Dominica"
        },
        {
            "countryName": "Dominican Republic",
            "id": "Dominican Republic"
        },
        {
            "countryName": "Ecuador",
            "id": "Ecuador"
        },
        {
            "countryName": "Egypt",
            "id": "Egypt"
        },
        {
            "countryName": "El Salvador",
            "id": "El Salvador"
        },
        {
            "countryName": "Equatorial Guinea",
            "id": "Equatorial Guinea"
        },
        {
            "countryName": "Eritrea",
            "id": "Eritrea"
        },
        {
            "countryName": "Estonia",
            "id": "Estonia"
        },
        {
            "countryName": "Ethiopia",
            "id": "Ethiopia"
        },
        {
            "countryName": "Falkland Islands (Malvinas)",
            "id": "Falkland Islands (Malvinas)"
        },
        {
            "countryName": "Faroe Islands",
            "id": "Faroe Islands"
        },
        {
            "countryName": "Fiji",
            "id": "Fiji"
        },
        {
            "countryName": "Finland",
            "id": "Finland"
        },
        {
            "countryName": "France",
            "id": "France"
        },
        {
            "countryName": "French Guiana",
            "id": "French Guiana"
        },
        {
            "countryName": "French Polynesia",
            "id": "French Polynesia"
        },
        {
            "countryName": "French Southern Territories",
            "id": "French Southern Territories"
        },
        {
            "countryName": "Gabon",
            "id": "Gabon"
        },
        {
            "countryName": "Gambia",
            "id": "The Gambia"
        },
        {
            "countryName": "Georgia",
            "id": "Georgia"
        },
        {
            "countryName": "Germany",
            "id": "Germany"
        },
        {
            "countryName": "Ghana",
            "id": "Ghana"
        },
        {
            "countryName": "Gibraltar",
            "id": "Gibraltar"
        },
        {
            "countryName": "Greece",
            "id": "Greece"
        },
        {
            "countryName": "Greenland",
            "id": "Greenland"
        },
        {
            "countryName": "Grenada",
            "id": "Grenada"
        },
        {
            "countryName": "Guadeloupe",
            "id": "Guadeloupe"
        },
        {
            "countryName": "Guam",
            "id": "Guam"
        },
        {
            "countryName": "Guatemala",
            "id": "Guatemala"
        },
        {
            "countryName": "Guernsey",
            "id": "Guernsey"
        },
        {
            "countryName": "Guinea",
            "id": "Guinea"
        },
        {
            "countryName": "Guinea-bissau",
            "id": "Guinea-bissau"
        },
        {
            "countryName": "Guyana",
            "id": "Guyana"
        },
        {
            "countryName": "Haiti",
            "id": "Haiti"
        },
        {
            "countryName": "Heard & McDonald Islands",
            "id": "Heard Island and Mcdonald Islands"
        },
        {
            "countryName": "Holy See (Vatican City State)",
            "id": "Vatican City"
        },
        {
            "countryName": "Honduras",
            "id": "Honduras"
        },
        {
            "countryName": "Hong Kong",
            "id": "Hong Kong"
        },
        {
            "countryName": "Hungary",
            "id": "Hungary"
        },
        {
            "countryName": "Iceland",
            "id": "Iceland"
        },
        {
            "countryName": "India",
            "id": "India"
        },
        {
            "countryName": "Indonesia",
            "id": "Indonesia"
        },
        {
            "countryName": "Iran",
            "id": "Iran"
        },
        {
            "countryName": "Iraq",
            "id": "Iraq"
        },
        {
            "countryName": "Ireland",
            "id": "Ireland"
        },
        {
            "countryName": "Isle of Man",
            "id": "Isle of Man"
        },
        {
            "countryName": "Israel",
            "id": "Israel"
        },
        {
            "countryName": "Italy",
            "id": "Italy"
        },
        {
            "countryName": "Jamaica",
            "id": "Jamaica"
        },
        {
            "countryName": "Japan",
            "id": "Japan"
        },
        {
            "countryName": "Jersey",
            "id": "Jersey"
        },
        {
            "countryName": "Jordan",
            "id": "Jordan"
        },
        {
            "countryName": "Kazakhstan",
            "id": "Kazakhstan"
        },
        {
            "countryName": "Kenya",
            "id": "Kenya"
        },
        {
            "countryName": "Kiribati",
            "id": "Kiribati"
        },
        {
            "countryName": "North Korea",
            "id": "North Korea"
        },
        {
            "countryName": "South Korea",
            "id": "South Korea"
        },
        {
            "countryName": "Kuwait",
            "id": "Kuwait"
        },
        {
            "countryName": "Kyrgyzstan",
            "id": "Kyrgyzstan"
        },
        {
            "countryName": "Laos",
            "id": "Laos"
        },
        {
            "countryName": "Latvia",
            "id": "Latvia"
        },
        {
            "countryName": "Lebanon",
            "id": "Lebanon"
        },
        {
            "countryName": "Lesotho",
            "id": "Lesotho"
        },
        {
            "countryName": "Liberia",
            "id": "Liberia"
        },
        {
            "countryName": "Libya",
            "id": "Libya"
        },
        {
            "countryName": "Liechtenstein",
            "id": "Liechtenstein"
        },
        {
            "countryName": "Lithuania",
            "id": "Lithuania"
        },
        {
            "countryName": "Luxembourg",
            "id": "Luxembourg"
        },
        {
            "countryName": "Macao",
            "id": "Macao"
        },
        {
            "countryName": "Macedonia, The Former Yugoslav Republic of",
            "id": "North Macedonia"
        },
        {
            "countryName": "Madagascar",
            "id": "Madagascar"
        },
        {
            "countryName": "Malawi",
            "id": "Malawi"
        },
        {
            "countryName": "Malaysia",
            "id": "Malaysia"
        },
        {
            "countryName": "Maldives",
            "id": "Maldives"
        },
        {
            "countryName": "Mali",
            "id": "Mali"
        },
        {
            "countryName": "Malta",
            "id": "Malta"
        },
        {
            "countryName": "Marshall Islands",
            "id": "Marshall Islands"
        },
        {
            "countryName": "Martinique",
            "id": "Martinique"
        },
        {
            "countryName": "Mauritania",
            "id": "Mauritania"
        },
        {
            "countryName": "Mauritius",
            "id": "Mauritius"
        },
        {
            "countryName": "Mayotte",
            "id": "Mayotte"
        },
        {
            "countryName": "Mexico",
            "id": "Mexico"
        },
        {
            "countryName": "Micronesia",
            "id": "Federated States of Micronesia"
        },
        {
            "countryName": "Moldova",
            "id": "Republic of Moldova"
        },
        {
            "countryName": "Monaco",
            "id": "Monaco"
        },
        {
            "countryName": "Mongolia",
            "id": "Mongolia"
        },
        {
            "countryName": "Montenegro",
            "id": "Montenegro"
        },
        {
            "countryName": "Montserrat",
            "id": "Montserrat"
        },
        {
            "countryName": "Morocco",
            "id": "Morocco"
        },
        {
            "countryName": "Mozambique",
            "id": "Mozambique"
        },
        {
            "countryName": "Myanmar",
            "id": "Myanmar (Burma)"
        },
        {
            "countryName": "Namibia",
            "id": "Namibia"
        },
        {
            "countryName": "Nauru",
            "id": "Nauru"
        },
        {
            "countryName": "Nepal",
            "id": "Nepal"
        },
        {
            "countryName": "Netherlands",
            "id": "Netherlands"
        },
        {
            "countryName": "New Caledonia",
            "id": "New Caledonia"
        },
        {
            "countryName": "New Zealand",
            "id": "New Zealand"
        },
        {
            "countryName": "Nicaragua",
            "id": "Nicaragua"
        },
        {
            "countryName": "Niger",
            "id": "Niger"
        },
        {
            "countryName": "Nigeria",
            "id": "Nigeria"
        },
        {
            "countryName": "Niue",
            "id": "Niue"
        },
        {
            "countryName": "Norfolk Island",
            "id": "Norfolk Island"
        },
        {
            "countryName": "Northern Mariana Islands",
            "id": "Northern Mariana Islands"
        },
        {
            "countryName": "Norway",
            "id": "Norway"
        },
        {
            "countryName": "Oman",
            "id": "Oman"
        },
        {
            "countryName": "Pakistan",
            "id": "Pakistan"
        },
        {
            "countryName": "Palau",
            "id": "Palau"
        },
        {
            "countryName": "Palestine",
            "id": "Occupied Palestinian Territory"
        },
        {
            "countryName": "Panama",
            "id": "Panama"
        },
        {
            "countryName": "Papua New Guinea",
            "id": "Papua New Guinea"
        },
        {
            "countryName": "Paraguay",
            "id": "Paraguay"
        },
        {
            "countryName": "Peru",
            "id": "Peru"
        },
        {
            "countryName": "Philippines",
            "id": "Philippines"
        },
        {
            "countryName": "Pitcairn Islands",
            "id": "Pitcairn Islands"
        },
        {
            "countryName": "Poland",
            "id": "Poland"
        },
        {
            "countryName": "Portugal",
            "id": "Portugal"
        },
        {
            "countryName": "Puerto Rico",
            "id": "Puerto Rico"
        },
        {
            "countryName": "Qatar",
            "id": "Qatar"
        },
        {
            "countryName": "Réunion",
            "id": "Réunion"
        },
        {
            "countryName": "Romania",
            "id": "Romania"
        },
        {
            "countryName": "Russia",
            "id": "Russian Federation"
        },
        {
            "countryName": "Rwanda",
            "id": "Rwanda"
        },
        {
            "countryName": "Saint Helena",
            "id": "Saint Helena, Ascension and Tristan da Cunha"
        },
        {
            "countryName": "Saint Kitts and Nevis",
            "id": "Saint Kitts and Nevis"
        },
        {
            "countryName": "Saint Lucia",
            "id": "Saint Lucia"
        },
        {
            "countryName": "Saint Pierre and Miquelon",
            "id": "Saint Pierre and Miquelon"
        },
        {
            "countryName": "Saint Vincent and the Grenadines",
            "id": "Saint Vincent and the Grenadines"
        },
        {
            "countryName": "Samoa",
            "id": "Samoa"
        },
        {
            "countryName": "San Marino",
            "id": "San Marino"
        },
        {
            "countryName": "São Tomé & Príncipe",
            "id": "São Tomé and Príncipe"
        },
        {
            "countryName": "Saudi Arabia",
            "id": "Saudi Arabia"
        },
        {
            "countryName": "Senegal",
            "id": "Senegal"
        },
        {
            "countryName": "Serbia",
            "id": "Serbia"
        },
        {
            "countryName": "Seychelles",
            "id": "Seychelles"
        },
        {
            "countryName": "Sierra Leone",
            "id": "Sierra Leone"
        },
        {
            "countryName": "Singapore",
            "id": "Singapore"
        },
        {
            "countryName": "Slovakia",
            "id": "Slovakia"
        },
        {
            "countryName": "Slovenia",
            "id": "Slovenia"
        },
        {
            "countryName": "Solomon Islands",
            "id": "Solomon Islands"
        },
        {
            "countryName": "Somalia",
            "id": "Somalia"
        },
        {
            "countryName": "South Africa",
            "id": "South Africa"
        },
        {
            "countryName": "South Georgia and the South Sandwich Islands",
            "id": "South Georgia and the South Sandwich Islands"
        },
        {
            "countryName": "Spain",
            "id": "Spain"
        },
        {
            "countryName": "Sri Lanka",
            "id": "Sri Lanka"
        },
        {
            "countryName": "Sudan",
            "id": "Sudan"
        },
        {
            "countryName": "Suriname",
            "id": "Suriname"
        },
        {
            "countryName": "Svalbard and Jan Mayen",
            "id": "Svalbard and Jan Mayen"
        },
        {
            "countryName": "Swaziland",
            "id": "Eswatini"
        },
        {
            "countryName": "Sweden",
            "id": "Sweden"
        },
        {
            "countryName": "Switzerland",
            "id": "Switzerland"
        },
        {
            "countryName": "Syrian Arab Republic",
            "id": "Syrian Arab Republic"
        },
        {
            "countryName": "Taiwan",
            "id": "Taiwan"
        },
        {
            "countryName": "Tajikistan",
            "id": "Tajikistan"
        },
        {
            "countryName": "Tanzania",
            "id": "United Republic of Tanzania"
        },
        {
            "countryName": "Thailand",
            "id": "Thailand"
        },
        {
            "countryName": "Timor-Leste",
            "id": "Timor-Leste"
        },
        {
            "countryName": "Togo",
            "id": "Togo"
        },
        {
            "countryName": "Tokelau",
            "id": "Tokelau"
        },
        {
            "countryName": "Tonga",
            "id": "Tonga"
        },
        {
            "countryName": "Trinidad & Tobago",
            "id": "Trinidad and tobago"
        },
        {
            "countryName": "Tunisia",
            "id": "Tunisia"
        },
        {
            "countryName": "Turkey",
            "id": "Turkey"
        },
        {
            "countryName": "Turkmenistan",
            "id": "Turkmenistan"
        },
        {
            "countryName": "Turks and Caicos Islands",
            "id": "Turks and Caicos Islands"
        },
        {
            "countryName": "Tuvalu",
            "id": "Tuvalu"
        },
        {
            "countryName": "Uganda",
            "id": "Uganda"
        },
        {
            "countryName": "Ukraine",
            "id": "Ukraine"
        },
        {
            "countryName": "United Arab Emirates",
            "id": "United Arab Emirates"
        },
        {
            "countryName": "UK",
            "id": "GB"
        },
        {
            "countryName": "United States Minor Outlying Islands",
            "id": "United States Minor Outlying Islands"
        },
        {
            "countryName": "Uruguay",
            "id": "Uruguay"
        },
        {
            "countryName": "Uzbekistan",
            "id": "Uzbekistan"
        },
        {
            "countryName": "Vanuatu",
            "id": "Vanuatu"
        },
        {
            "countryName": "Venezuela",
            "id": "Venezuela"
        },
        {
            "countryName": "Vietnam",
            "id": "Vietnam"
        },
        {
            "countryName": "British Virgin Islands",
            "id": "British Virgin Islands"
        },
        {
            "countryName": "U.S. Virgin Islands",
            "id": "U.S. Virgin Islands"
        },
        {
            "countryName": "Wallis and Futuna",
            "id": "Wallis and Futuna"
        },
        {
            "countryName": "Western Sahara",
            "id": "Western Sahara"
        },
        {
            "countryName": "Yemen",
            "id": "Yemen"
        },
        {
            "countryName": "Zambia",
            "id": "Zambia"
        },
        {
            "countryName": "Zimbabwe",
            "id": "Zimbabwe"
        }
    ],
    "countryListFrench": [
        {
            "countryName": "Canada",
            "id": "Canada"
        },
        {
            "countryName": "États-Unis",
            "id": "USA"
        },
        {
            "countryName": "Afghanistan",
            "id": "Afghanistan"
        },
        {
            "countryName": "Iles Aland",
            "id": "Åland Islands"
        },
        {
            "countryName": "Albanie",
            "id": "Albania"
        },
        {
            "countryName": "Algérie",
            "id": "Algeria"
        },
        {
            "countryName": "Samoa Américaines",
            "id": "American Samoa"
        },
        {
            "countryName": "Andorre",
            "id": "Andorra"
        },
        {
            "countryName": "Angola",
            "id": "Angola"
        },
        {
            "countryName": "Anguilla",
            "id": "Anguilla"
        },
        {
            "countryName": "Antarctique",
            "id": "Antarctica"
        },
        {
            "countryName": "Antigua-et-Barbuda",
            "id": "Antigua and Barbuda"
        },
        {
            "countryName": "Argentine",
            "id": "Argentina"
        },
        {
            "countryName": "Arménie",
            "id": "Armenia"
        },
        {
            "countryName": "Aruba",
            "id": "Aruba"
        },
        {
            "countryName": "Australie",
            "id": "Australia"
        },
        {
            "countryName": "Autriche",
            "id": "Austria"
        },
        {
            "countryName": "Azerbaïdjan",
            "id": "Azerbaijan"
        },
        {
            "countryName": "Bahamas",
            "id": "The Bahamas"
        },
        {
            "countryName": "Bahreïn",
            "id": "Bahrain"
        },
        {
            "countryName": "Bangladesh",
            "id": "Bangladesh"
        },
        {
            "countryName": "Barbade",
            "id": "Barbados"
        },
        {
            "countryName": "Bélarus",
            "id": "Belarus"
        },
        {
            "countryName": "Belgique",
            "id": "Belgium"
        },
        {
            "countryName": "Belize",
            "id": "Belize"
        },
        {
            "countryName": "Bénin",
            "id": "Benin"
        },
        {
            "countryName": "Bermudes",
            "id": "Bermuda"
        },
        {
            "countryName": "Bhoutan",
            "id": "Bhutan"
        },
        {
            "countryName": "Bolivie",
            "id": "Bolivia"
        },
        {
            "countryName": "Bosnie-Herzégovine",
            "id": "Bosnia and Herzegovina"
        },
        {
            "countryName": "Botswana",
            "id": "Botswana"
        },
        {
            "countryName": "Île Bouvet",
            "id": "Bouvet Island"
        },
        {
            "countryName": "Brésil",
            "id": "Brazil"
        },
        {
            "countryName": "Territoire britannique de l\"océan Indien",
            "id": "British Indian Ocean Territory"
        },
        {
            "countryName": "Brunei",
            "id": "Brunei"
        },
        {
            "countryName": "Bulgarie",
            "id": "Bulgaria"
        },
        {
            "countryName": "Burkina Faso",
            "id": "Burkina Faso"
        },
        {
            "countryName": "Burundi",
            "id": "Burundi"
        },
        {
            "countryName": "Cambodge",
            "id": "Cambodia"
        },
        {
            "countryName": "Cameroun",
            "id": "Cameroon"
        },
        {
            "countryName": "Cap-Vert",
            "id": "Cape Verde"
        },
        {
            "countryName": "Îles Caïmans",
            "id": "Cayman Islands"
        },
        {
            "countryName": "Centrafricaine, République",
            "id": "Central African Republic"
        },
        {
            "countryName": "Tchad",
            "id": "Chad"
        },
        {
            "countryName": "Chili",
            "id": "Chile"
        },
        {
            "countryName": "Chine",
            "id": "China"
        },
        {
            "countryName": "Île Christmas",
            "id": "Christmas Island"
        },
        {
            "countryName": "Îles Cocos (Keeling)",
            "id": "Cocos (Keeling) Islands"
        },
        {
            "countryName": "Colombie",
            "id": "Colombia"
        },
        {
            "countryName": "Comores",
            "id": "Comoros"
        },
        {
            "countryName": "Congo",
            "id": "Congo"
        },
        {
            "countryName": "Congo - Brazzaville",
            "id": "Congo - Brazzaville"
        },
        {
            "countryName": "Îles Cook",
            "id": "Cook Islands"
        },
        {
            "countryName": "Costa Rica",
            "id": "Costa Rica"
        },
        {
            "countryName": "Côte d’Ivoire",
            "id": "Côte d'Ivoire"
        },
        {
            "countryName": "Croatie",
            "id": "Croatia"
        },
        {
            "countryName": "Cuba",
            "id": "Cuba"
        },
        {
            "countryName": "Chypre",
            "id": "Cyprus"
        },
        {
            "countryName": "République Tchèque",
            "id": "Czechia"
        },
        {
            "countryName": "Danemark",
            "id": "Denmark"
        },
        {
            "countryName": "Djibouti",
            "id": "Djibouti"
        },
        {
            "countryName": "Dominique",
            "id": "Dominica"
        },
        {
            "countryName": "Dominicaine République",
            "id": "Dominican Republic"
        },
        {
            "countryName": "Équateur",
            "id": "Ecuador"
        },
        {
            "countryName": "Égypte",
            "id": "Egypt"
        },
        {
            "countryName": "El Salvador",
            "id": "El Salvador"
        },
        {
            "countryName": "Guinée Équatoriale",
            "id": "Equatorial Guinea"
        },
        {
            "countryName": "Érythrée",
            "id": "Eritrea"
        },
        {
            "countryName": "Estonie",
            "id": "Estonia"
        },
        {
            "countryName": "Éthiopie",
            "id": "Ethiopia"
        },
        {
            "countryName": "Falkland, Îles (Malvinas)",
            "id": "Falkland Islands (Malvinas)"
        },
        {
            "countryName": "Îles Féroé",
            "id": "Faroe Islands"
        },
        {
            "countryName": "Fid'ji",
            "id": "Fiji"
        },
        {
            "countryName": "Finlande",
            "id": "Finland"
        },
        {
            "countryName": "France",
            "id": "France"
        },
        {
            "countryName": "Guyane Française",
            "id": "French Guiana"
        },
        {
            "countryName": "Polynésie Française",
            "id": "French Polynesia"
        },
        {
            "countryName": "Terres australes françaises",
            "id": "French Southern Territories"
        },
        {
            "countryName": "Gabon",
            "id": "Gabon"
        },
        {
            "countryName": "Gambie",
            "id": "The Gambia"
        },
        {
            "countryName": "Géorgie",
            "id": "Georgia"
        },
        {
            "countryName": "Allemagne",
            "id": "Germany"
        },
        {
            "countryName": "Ghana",
            "id": "Ghana"
        },
        {
            "countryName": "Gibraltar",
            "id": "Gibraltar"
        },
        {
            "countryName": "Grèce",
            "id": "Greece"
        },
        {
            "countryName": "Groenland",
            "id": "Greenland"
        },
        {
            "countryName": "Grenade",
            "id": "Grenada"
        },
        {
            "countryName": "Guadeloupe",
            "id": "Guadeloupe"
        },
        {
            "countryName": "Guam",
            "id": "Guam"
        },
        {
            "countryName": "Guatemala",
            "id": "Guatemala"
        },
        {
            "countryName": "Guernesey",
            "id": "Guernsey"
        },
        {
            "countryName": "Guinée",
            "id": "Guinea"
        },
        {
            "countryName": "Guinée-Bissau",
            "id": "Guinea-bissau"
        },
        {
            "countryName": "Guyana",
            "id": "Guyana"
        },
        {
            "countryName": "Haïti",
            "id": "Haiti"
        },
        {
            "countryName": "Îles Heard et McDonald",
            "id": "Heard Island and Mcdonald Islands"
        },
        {
            "countryName": "Saint-Siège (État de la Cité du Vatican)",
            "id": "Vatican City"
        },
        {
            "countryName": "Honduras",
            "id": "Honduras"
        },
        {
            "countryName": "Hong-Kong",
            "id": "Hong Kong"
        },
        {
            "countryName": "Hongrie",
            "id": "Hungary"
        },
        {
            "countryName": "Islande",
            "id": "Iceland"
        },
        {
            "countryName": "Inde",
            "id": "India"
        },
        {
            "countryName": "Indonésie",
            "id": "Indonesia"
        },
        {
            "countryName": "L'Iran",
            "id": "Iran"
        },
        {
            "countryName": "Iraq",
            "id": "Iraq"
        },
        {
            "countryName": "Irlande",
            "id": "Ireland"
        },
        {
            "countryName": "île de Man",
            "id": "Isle of Man"
        },
        {
            "countryName": "Israël",
            "id": "Israel"
        },
        {
            "countryName": "Italie",
            "id": "Italy"
        },
        {
            "countryName": "Jamaïque",
            "id": "Jamaica"
        },
        {
            "countryName": "Japon",
            "id": "Japan"
        },
        {
            "countryName": "Jersey",
            "id": "Jersey"
        },
        {
            "countryName": "Jordanie",
            "id": "Jordan"
        },
        {
            "countryName": "Kazakstan",
            "id": "Kazakhstan"
        },
        {
            "countryName": "Kenya",
            "id": "Kenya"
        },
        {
            "countryName": "Kiribati",
            "id": "Kiribati"
        },
        {
            "countryName": "Corée du Nord",
            "id": "North Korea"
        },
        {
            "countryName": "Corée du Sud",
            "id": "South Korea"
        },
        {
            "countryName": "Koweït",
            "id": "Kuwait"
        },
        {
            "countryName": "Kirghizistan",
            "id": "Kyrgyzstan"
        },
        {
            "countryName": "Laos",
            "id": "Laos"
        },
        {
            "countryName": "Lettonie",
            "id": "Latvia"
        },
        {
            "countryName": "Liban",
            "id": "Lebanon"
        },
        {
            "countryName": "Lesotho",
            "id": "Lesotho"
        },
        {
            "countryName": "Libéria",
            "id": "Liberia"
        },
        {
            "countryName": "Libye",
            "id": "Libye"
        },
        {
            "countryName": "Liechtenstein",
            "id": "Liechtenstein"
        },
        {
            "countryName": "Lituanie",
            "id": "Lithuania"
        },
        {
            "countryName": "Luxembourg",
            "id": "Luxembourg"
        },
        {
            "countryName": "Macao",
            "id": "Macao"
        },
        {
            "countryName": "Macédoine du Nord",
            "id": "North Macedonia"
        },
        {
            "countryName": "Madagascar",
            "id": "Madagascar"
        },
        {
            "countryName": "Malawi",
            "id": "Malawi"
        },
        {
            "countryName": "Malaisie",
            "id": "Malaysia"
        },
        {
            "countryName": "Maldives",
            "id": "Maldives"
        },
        {
            "countryName": "Mali",
            "id": "Mali"
        },
        {
            "countryName": "Malte",
            "id": "Malta"
        },
        {
            "countryName": "Îles Marshall",
            "id": "Marshall Islands"
        },
        {
            "countryName": "Martinique",
            "id": "Martinique"
        },
        {
            "countryName": "Mauritanie",
            "id": "Mauritania"
        },
        {
            "countryName": "Île Maurice",
            "id": "Mauritius"
        },
        {
            "countryName": "Mayotte",
            "id": "Mayotte"
        },
        {
            "countryName": "Mexique",
            "id": "Mexico"
        },
        {
            "countryName": "Micronésie",
            "id": "Federated States of Micronesia"
        },
        {
            "countryName": "Moldavie",
            "id": "Republic of Moldova"
        },
        {
            "countryName": "Monaco",
            "id": "Monaco"
        },
        {
            "countryName": "Mongolie",
            "id": "Mongolia"
        },
        {
            "countryName": "Monténégro",
            "id": "Montenegro"
        },
        {
            "countryName": "Montserrat",
            "id": "Montserrat"
        },
        {
            "countryName": "Maroc",
            "id": "Morocco"
        },
        {
            "countryName": "Mozambique",
            "id": "Mozambique"
        },
        {
            "countryName": "Myanmar",
            "id": "Myanmar (Burma)"
        },
        {
            "countryName": "Namibie",
            "id": "Namibia"
        },
        {
            "countryName": "Nauru",
            "id": "Nauru"
        },
        {
            "countryName": "Népal",
            "id": "Nepal"
        },
        {
            "countryName": "Pays-Bas",
            "id": "Netherlands"
        },
        {
            "countryName": "Nouvelle-Calédonie",
            "id": "New Caledonia"
        },
        {
            "countryName": "Nouvelle-Zélande",
            "id": "New Zealand"
        },
        {
            "countryName": "Nicaragua",
            "id": "Nicaragua"
        },
        {
            "countryName": "Niger",
            "id": "Niger"
        },
        {
            "countryName": "Nigéria",
            "id": "Nigeria"
        },
        {
            "countryName": "Nioué",
            "id": "Niue"
        },
        {
            "countryName": "l\"ile de Norfolk",
            "id": "Norfolk Island"
        },
        {
            "countryName": "Îles Mariannes du Nord",
            "id": "Northern Mariana Islands"
        },
        {
            "countryName": "Norvège",
            "id": "Norway"
        },
        {
            "countryName": "Oman",
            "id": "Oman"
        },
        {
            "countryName": "Pakistan",
            "id": "Pakistan"
        },
        {
            "countryName": "Palaos",
            "id": "Palau"
        },
        {
            "countryName": "Palestine",
            "id": "Occupied Palestinian Territory"
        },
        {
            "countryName": "Panama",
            "id": "Panama"
        },
        {
            "countryName": "Papouasie-Nouvelle-Guinée",
            "id": "Papua New Guinea"
        },
        {
            "countryName": "Paraguay",
            "id": "Paraguay"
        },
        {
            "countryName": "Pérou",
            "id": "Peru"
        },
        {
            "countryName": "Philippines",
            "id": "Philippines"
        },
        {
            "countryName": "Îles Pitcairn",
            "id": "Pitcairn Islands"
        },
        {
            "countryName": "Pologne",
            "id": "Poland"
        },
        {
            "countryName": "Portugal",
            "id": "Portugal"
        },
        {
            "countryName": "Porto Rico",
            "id": "Puerto Rico"
        },
        {
            "countryName": "Qatar",
            "id": "Qatar"
        },
        {
            "countryName": "Réunion",
            "id": "Réunion"
        },
        {
            "countryName": "Roumanie",
            "id": "Romania"
        },
        {
            "countryName": "Russie",
            "id": "Russian Federation"
        },
        {
            "countryName": "Rwanda",
            "id": "Rwanda"
        },
        {
            "countryName": "Sainte-Hélène",
            "id": "Saint Helena, Ascension and Tristan da Cunha"
        },
        {
            "countryName": "Saint-Kitts-et-Nevis",
            "id": "Saint Kitts and Nevis"
        },
        {
            "countryName": "Sainte-Lucie",
            "id": "Saint Lucia"
        },
        {
            "countryName": "Saint-Pierre-et-Miquelon",
            "id": "Saint Pierre and Miquelon"
        },
        {
            "countryName": "Saint-Vincent-et-les Grenadines",
            "id": "Saint Vincent and the Grenadines"
        },
        {
            "countryName": "Samoa",
            "id": "Samoa"
        },
        {
            "countryName": "Saint-Marin",
            "id": "San Marino"
        },
        {
            "countryName": "São Tomé et Príncipe",
            "id": "São Tomé and Príncipe"
        },
        {
            "countryName": "Arabie Saoudite",
            "id": "Saudi Arabia"
        },
        {
            "countryName": "Sénégal",
            "id": "Senegal"
        },
        {
            "countryName": "Serbie",
            "id": "Serbia"
        },
        {
            "countryName": "Seychelles",
            "id": "Seychelles"
        },
        {
            "countryName": "Sierra Leone",
            "id": "Sierra Leone"
        },
        {
            "countryName": "Singapour",
            "id": "Singapore"
        },
        {
            "countryName": "Slovaquie",
            "id": "Slovakia"
        },
        {
            "countryName": "Slovénie",
            "id": "Slovenia"
        },
        {
            "countryName": "Salomon, Îles",
            "id": "Solomon Islands"
        },
        {
            "countryName": "Somalie",
            "id": "Somalia"
        },
        {
            "countryName": "Afrique du Sud",
            "id": "South Africa"
        },
        {
            "countryName": "Géorgie du Sud et les îles Sandwich du Sud",
            "id": "South Georgia and the South Sandwich Islands"
        },
        {
            "countryName": "Espagne",
            "id": "Spain"
        },
        {
            "countryName": "Sri Lanka",
            "id": "Sri Lanka"
        },
        {
            "countryName": "Soudan",
            "id": "Sudan"
        },
        {
            "countryName": "Suriname",
            "id": "Suriname"
        },
        {
            "countryName": "Svalbard et Jan Mayen",
            "id": "Svalbard and Jan Mayen"
        },
        {
            "countryName": "Swaziland",
            "id": "Eswatini"
        },
        {
            "countryName": "Suède",
            "id": "Sweden"
        },
        {
            "countryName": "Suisse",
            "id": "Switzerland"
        },
        {
            "countryName": "Syrienne, République Arabe",
            "id": "Syrian Arab Republic"
        },
        {
            "countryName": "Taïwan",
            "id": "Taiwan"
        },
        {
            "countryName": "Tadjikistan",
            "id": "Tajikistan"
        },
        {
            "countryName": "Tanzanie",
            "id": "United Republic of Tanzania"
        },
        {
            "countryName": "Thaïlande",
            "id": "Thailand"
        },
        {
            "countryName": "Timor-Leste (Timor Oriental)",
            "id": "Timor-Leste"
        },
        {
            "countryName": "Togo",
            "id": "Togo"
        },
        {
            "countryName": "Tokelau",
            "id": "Tokelau"
        },
        {
            "countryName": "Tonga",
            "id": "Tonga"
        },
        {
            "countryName": "Trinité-et-Tobago",
            "id": "Trinidad and tobago"
        },
        {
            "countryName": "Tunisie",
            "id": "Tunisia"
        },
        {
            "countryName": "Turquie",
            "id": "Turkey"
        },
        {
            "countryName": "Turkménistan",
            "id": "Turkmenistan"
        },
        {
            "countryName": "Turks et Caïques, Îles",
            "id": "Turks and Caicos Islands"
        },
        {
            "countryName": "Tuvalu",
            "id": "Tuvalu"
        },
        {
            "countryName": "Ouganda",
            "id": "Uganda"
        },
        {
            "countryName": "Ukraine",
            "id": "Ukraine"
        },
        {
            "countryName": "Émirats Arabes Unis",
            "id": "United Arab Emirates"
        },
        {
            "countryName": "Royaume-Uni",
            "id": "GB"
        },
        {
            "countryName": "Îles mineures éloignées des États-Unis",
            "id": "United States Minor Outlying Islands"
        },
        {
            "countryName": "Uruguay",
            "id": "Uruguay"
        },
        {
            "countryName": "Ouzbékistan",
            "id": "Uzbekistan"
        },
        {
            "countryName": "Vanuatu",
            "id": "Vanuatu"
        },
        {
            "countryName": "Venezuela",
            "id": "Venezuela"
        },
        {
            "countryName": "Vietnam",
            "id": "Vietnam"
        },
        {
            "countryName": "Îles Vierges britanniques",
            "id": "British Virgin Islands"
        },
        {
            "countryName": "Îles Vierges américaines",
            "id": "U.S. Virgin Islands"
        },
        {
            "countryName": "Wallis et Futuna",
            "id": "Wallis and Futuna"
        },
        {
            "countryName": "Sahara Occ'id'ental",
            "id": "Western Sahara"
        },
        {
            "countryName": "Yémen",
            "id": "Yemen"
        },
        {
            "countryName": "Zambie",
            "id": "Zambia"
        },
        {
            "countryName": "Zimbabwe",
            "id": "Zimbabwe"
        }
    ],
    "provinceListCanada": [
        {
            "id": "AB",
            "provinceName": "Alberta",
            "provinceCode": "Alberta"
        },
        {
            "id": "ON",
            "provinceName": "Ontario",
            "provinceCode": "Ontario"
        },
        {
            "id": "BC",
            "provinceName": "British Columbia",
            "provinceCode": "British Columbia"
        },
        {
            "id": "MB",
            "provinceName": "Manitoba",
            "provinceCode": "Manitoba"
        },
        {
            "id": "NL",
            "provinceName": "Newfoundland and Labrador",
            "provinceCode": "Newfoundland and Labrador"
        },
        {
            "id": "PE",
            "provinceName": "Prince Edward Island",
            "provinceCode": "Prince Edward Island"
        },
        {
            "id": "NS",
            "provinceName": "Nova Scotia",
            "provinceCode": "Nova Scotia"
        },
        {
            "id": "NB",
            "provinceName": "New Brunswick",
            "provinceCode": "New Brunswick"
        },
        {
            "id": "QC",
            "provinceName": "Quebec",
            "provinceCode": "Quebec"
        },
        {
            "id": "YT",
            "provinceName": "Yukon",
            "provinceCode": "Yukon"
        },
        {
            "id": "NT",
            "provinceName": "Northwest Territories",
            "provinceCode": "Northwest Territories"
        },
        {
            "id": "NU",
            "provinceName": "Nunavat",
            "provinceCode": "Nunavat"
        },
        {
            "id": "SK",
            "provinceName": "Saskatchewan",
            "provinceCode": "Saskatchewan"
        }
    ],
    "provinceListCanadaFrench": [
        {
            "id": "AB",
            "provinceName": "Alberta",
            "provinceCode": "Alberta"
        },
        {
            "id": "ON",
            "provinceName": "Ontario",
            "provinceCode": "Ontario"
        },
        {
            "id": "BC",
            "provinceName": "Colombie-Britannique",
            "provinceCode": "British Columbia"
        },
        {
            "id": "MB",
            "provinceName": "Manitoba",
            "provinceCode": "Manitoba"
        },
        {
            "id": "NL",
            "provinceName": "Terre-Neuve-et-Labrador",
            "provinceCode": "Newfoundland and Labrador"
        },
        {
            "id": "PE",
            "provinceName": "Île-du-Prince-Édouard",
            "provinceCode": "Prince Edward Island"
        },
        {
            "id": "NS",
            "provinceName": "Nouvelle-Écosse",
            "provinceCode": "Nova Scotia"
        },
        {
            "id": "NB",
            "provinceName": "Nouveau-Brunswick",
            "provinceCode": "New Brunswick"
        },
        {
            "id": "QC",
            "provinceName": "Québec",
            "provinceCode": "Quebec"
        },
        {
            "id": "YT",
            "provinceName": "Yukon",
            "provinceCode": "Yukon"
        },
        {
            "id": "NT",
            "provinceName": "Territoires du Nord-Ouest",
            "provinceCode": "Northwest Territories"
        },
        {
            "id": "NU",
            "provinceName": "Nunavat",
            "provinceCode": "Nunavat"
        },
        {
            "id": "SK",
            "provinceName": "Saskatchewan",
            "provinceCode": "Saskatchewan"
        }
    ],
    "provinceListUSA": [
        {
            "provinceName": "Alabama",
            "provinceCode": "Alabama",
            "id": "AL"
        },
        {
            "provinceName": "Alaska",
            "provinceCode": "Alaska",
            "id": "AK"
        },
        {
            "provinceName": "American Samoa",
            "provinceCode": "American Samoa",
            "id": "AS"
        },
        {
            "provinceName": "Arizona",
            "provinceCode": "Arizona",
            "id": "AZ"
        },
        {
            "provinceName": "Arkansas",
            "provinceCode": "Arkansas",
            "id": "AR"
        },
        {
            "provinceName": "California",
            "provinceCode": "California",
            "id": "CA"
        },
        {
            "provinceName": "Colorado",
            "provinceCode": "Colorado",
            "id": "CO"
        },
        {
            "provinceName": "Connecticut",
            "provinceCode": "Connecticut",
            "id": "CT"
        },
        {
            "provinceName": "Delaware",
            "provinceCode": "Delaware",
            "id": "DE"
        },
        {
            "provinceName": "District Of Columbia",
            "provinceCode": "District Of Columbia",
            "id": "DC"
        },
        {
            "provinceName": "Federated States Of Micronesia",
            "provinceCode": "Federated States Of Micronesia",
            "id": "FM"
        },
        {
            "provinceName": "Florida",
            "provinceCode": "Florida",
            "id": "FL"
        },
        {
            "provinceName": "Georgia",
            "provinceCode": "Georgia",
            "id": "GA"
        },
        {
            "provinceName": "Guam",
            "provinceCode": "Guam",
            "id": "GU"
        },
        {
            "provinceName": "Hawaii",
            "provinceCode": "Hawaii",
            "id": "HI"
        },
        {
            "provinceName": "Idaho",
            "provinceCode": "Idaho",
            "id": "id"
        },
        {
            "provinceName": "Illinois",
            "provinceCode": "Illinois",
            "id": "IL"
        },
        {
            "provinceName": "Indiana",
            "provinceCode": "Indiana",
            "id": "IN"
        },
        {
            "provinceName": "Iowa",
            "provinceCode": "Iowa",
            "id": "IA"
        },
        {
            "provinceName": "Kansas",
            "provinceCode": "Kansas",
            "id": "KS"
        },
        {
            "provinceName": "Kentucky",
            "provinceCode": "Kentucky",
            "id": "KY"
        },
        {
            "provinceName": "Louisiana",
            "provinceCode": "Louisiana",
            "id": "LA"
        },
        {
            "provinceName": "Maine",
            "provinceCode": "Maine",
            "id": "ME"
        },
        {
            "provinceName": "Marshall Islands",
            "provinceCode": "Marshall Islands",
            "id": "MH"
        },
        {
            "provinceName": "Maryland",
            "provinceCode": "Maryland",
            "id": "MD"
        },
        {
            "provinceName": "Massachusetts",
            "provinceCode": "Massachusetts",
            "id": "MA"
        },
        {
            "provinceName": "Michigan",
            "provinceCode": "Michigan",
            "id": "MI"
        },
        {
            "provinceName": "Minnesota",
            "provinceCode": "Minnesota",
            "id": "MN"
        },
        {
            "provinceName": "Mississippi",
            "provinceCode": "Mississippi",
            "id": "MS"
        },
        {
            "provinceName": "Missouri",
            "provinceCode": "Missouri",
            "id": "MO"
        },
        {
            "provinceName": "Montana",
            "provinceCode": "Montana",
            "id": "MT"
        },
        {
            "provinceName": "Nebraska",
            "provinceCode": "Nebraska",
            "id": "NE"
        },
        {
            "provinceName": "Nevada",
            "provinceCode": "Nevada",
            "id": "NV"
        },
        {
            "provinceName": "New Hampshire",
            "provinceCode": "New Hampshire",
            "id": "NH"
        },
        {
            "provinceName": "New Jersey",
            "provinceCode": "New Jersey",
            "id": "NJ"
        },
        {
            "provinceName": "New Mexico",
            "provinceCode": "New Mexico",
            "id": "NM"
        },
        {
            "provinceName": "New York",
            "provinceCode": "New York",
            "id": "NY"
        },
        {
            "provinceName": "North Carolina",
            "provinceCode": "North Carolina",
            "id": "NC"
        },
        {
            "provinceName": "North Dakota",
            "provinceCode": "North Dakota",
            "id": "ND"
        },
        {
            "provinceName": "Northern Mariana Islands",
            "provinceCode": "Northern Mariana Islands",
            "id": "MP"
        },
        {
            "provinceName": "Ohio",
            "provinceCode": "Ohio",
            "id": "OH"
        },
        {
            "provinceName": "Oklahoma",
            "provinceCode": "Oklahoma",
            "id": "OK"
        },
        {
            "provinceName": "Oregon",
            "provinceCode": "Oregon",
            "id": "OR"
        },
        {
            "provinceName": "Palau",
            "provinceCode": "Palau",
            "id": "PW"
        },
        {
            "provinceName": "Pennsylvania",
            "provinceCode": "Pennsylvania",
            "id": "PA"
        },
        {
            "provinceName": "Puerto Rico",
            "provinceCode": "Puerto Rico",
            "id": "PR"
        },
        {
            "provinceName": "Rhode Island",
            "provinceCode": "Rhode Island",
            "id": "RI"
        },
        {
            "provinceName": "South Carolina",
            "provinceCode": "South Carolina",
            "id": "SC"
        },
        {
            "provinceName": "South Dakota",
            "provinceCode": "South Dakota",
            "id": "SD"
        },
        {
            "provinceName": "Tennessee",
            "provinceCode": "Tennessee",
            "id": "TN"
        },
        {
            "provinceName": "Texas",
            "provinceCode": "Texas",
            "id": "TX"
        },
        {
            "provinceName": "Utah",
            "provinceCode": "Utah",
            "id": "UT"
        },
        {
            "provinceName": "Vermont",
            "provinceCode": "Vermont",
            "id": "VT"
        },
        {
            "provinceName": "Virgin Islands",
            "provinceCode": "Virgin Islands",
            "id": "VI"
        },
        {
            "provinceName": "Virginia",
            "provinceCode": "Virginia",
            "id": "VA"
        },
        {
            "provinceName": "Washington",
            "provinceCode": "Washington",
            "id": "WA"
        },
        {
            "provinceName": "West Virginia",
            "provinceCode": "West Virginia",
            "id": "WV"
        },
        {
            "provinceName": "Wisconsin",
            "provinceCode": "Wisconsin",
            "id": "WI"
        },
        {
            "provinceName": "Wyoming",
            "provinceCode": "Wyoming",
            "id": "WY"
        }
    ],
    "provinceListUSAFrench": [
        {
            "provinceName": "Alabama",
            "provinceCode": "Alabama",
            "id": "AL"
        },
        {
            "provinceName": "Alaska",
            "provinceCode": "Alaska",
            "id": "AK"
        },
        {
            "provinceName": "samoa américaines",
            "provinceCode": "American Samoa",
            "id": "AS"
        },
        {
            "provinceName": "Arizona",
            "provinceCode": "Arizona",
            "id": "AZ"
        },
        {
            "provinceName": "Arkansas",
            "provinceCode": "Arkansas",
            "id": "AR"
        },
        {
            "provinceName": "Californie",
            "provinceCode": "California",
            "id": "CA"
        },
        {
            "provinceName": "Colorado",
            "provinceCode": "Colorado",
            "id": "CO"
        },
        {
            "provinceName": "Connecticut",
            "provinceCode": "Connecticut",
            "id": "CT"
        },
        {
            "provinceName": "Delaware",
            "provinceCode": "Delaware",
            "id": "DE"
        },
        {
            "provinceName": "District de Colombie",
            "provinceCode": "District Of Columbia",
            "id": "DC"
        },
        {
            "provinceName": "États fédérés de Micronésie",
            "provinceCode": "Federated States Of Micronesia",
            "id": "FM"
        },
        {
            "provinceName": "Floride",
            "provinceCode": "Florida",
            "id": "FL"
        },
        {
            "provinceName": "Géorgie",
            "provinceCode": "Georgia",
            "id": "GA"
        },
        {
            "provinceName": "Guam",
            "provinceCode": "Guam",
            "id": "GU"
        },
        {
            "provinceName": "Hawaï",
            "provinceCode": "Hawaii",
            "id": "HI"
        },
        {
            "provinceName": "Idaho",
            "provinceCode": "Idaho",
            "id": "id"
        },
        {
            "provinceName": "Illinois",
            "provinceCode": "Illinois",
            "id": "IL"
        },
        {
            "provinceName": "Indiana",
            "provinceCode": "Indiana",
            "id": "IN"
        },
        {
            "provinceName": "Iowa",
            "provinceCode": "Iowa",
            "id": "IA"
        },
        {
            "provinceName": "Kansas",
            "provinceCode": "Kansas",
            "id": "KS"
        },
        {
            "provinceName": "Kentucky",
            "provinceCode": "Kentucky",
            "id": "KY"
        },
        {
            "provinceName": "Louisiane",
            "provinceCode": "Louisiana",
            "id": "LA"
        },
        {
            "provinceName": "Maine",
            "provinceCode": "Maine",
            "id": "ME"
        },
        {
            "provinceName": "Iles Marshall",
            "provinceCode": "Marshall Islands",
            "id": "MH"
        },
        {
            "provinceName": "Maryland",
            "provinceCode": "Maryland",
            "id": "MD"
        },
        {
            "provinceName": "Massachusetts",
            "provinceCode": "Massachusetts",
            "id": "MA"
        },
        {
            "provinceName": "Michigan",
            "provinceCode": "Michigan",
            "id": "MI"
        },
        {
            "provinceName": "Minnesota",
            "provinceCode": "Minnesota",
            "id": "MN"
        },
        {
            "provinceName": "Mississippi",
            "provinceCode": "Mississippi",
            "id": "MS"
        },
        {
            "provinceName": "Missouri",
            "provinceCode": "Missouri",
            "id": "MO"
        },
        {
            "provinceName": "Montana",
            "provinceCode": "Montana",
            "id": "MT"
        },
        {
            "provinceName": "Nebraska",
            "provinceCode": "Nebraska",
            "id": "NE"
        },
        {
            "provinceName": "Nevada",
            "provinceCode": "Nevada",
            "id": "NV"
        },
        {
            "provinceName": "New Hampshire",
            "provinceCode": "New Hampshire",
            "id": "NH"
        },
        {
            "provinceName": "New Jersey",
            "provinceCode": "New Jersey",
            "id": "NJ"
        },
        {
            "provinceName": "Nouveau Mexique",
            "provinceCode": "New Mexico",
            "id": "NM"
        },
        {
            "provinceName": "New York",
            "provinceCode": "New York",
            "id": "NY"
        },
        {
            "provinceName": "Caroline du Nord",
            "provinceCode": "North Carolina",
            "id": "NC"
        },
        {
            "provinceName": "Dakota du nord",
            "provinceCode": "North Dakota",
            "id": "ND"
        },
        {
            "provinceName": "Îles Mariannes du Nord",
            "provinceCode": "Northern Mariana Islands",
            "id": "MP"
        },
        {
            "provinceName": "Ohio",
            "provinceCode": "Ohio",
            "id": "OH"
        },
        {
            "provinceName": "Oklahoma",
            "provinceCode": "Oklahoma",
            "id": "OK"
        },
        {
            "provinceName": "Oregon",
            "provinceCode": "Oregon",
            "id": "OR"
        },
        {
            "provinceName": "Palau",
            "provinceCode": "Palau",
            "id": "PW"
        },
        {
            "provinceName": "Pennsylvanie",
            "provinceCode": "Pennsylvania",
            "id": "PA"
        },
        {
            "provinceName": "Porto Rico",
            "provinceCode": "Puerto Rico",
            "id": "PR"
        },
        {
            "provinceName": "Rhode Island",
            "provinceCode": "Rhode Island",
            "id": "RI"
        },
        {
            "provinceName": "Caroline du Sud",
            "provinceCode": "South Carolina",
            "id": "SC"
        },
        {
            "provinceName": "Dakota du Sud",
            "provinceCode": "South Dakota",
            "id": "SD"
        },
        {
            "provinceName": "Tennessee",
            "provinceCode": "Tennessee",
            "id": "TN"
        },
        {
            "provinceName": "Texas",
            "provinceCode": "Texas",
            "id": "TX"
        },
        {
            "provinceName": "Utah",
            "provinceCode": "Utah",
            "id": "UT"
        },
        {
            "provinceName": "Vermont",
            "provinceCode": "Vermont",
            "id": "VT"
        },
        {
            "provinceName": "Les iles vierges",
            "provinceCode": "Virgin Islands",
            "id": "VI"
        },
        {
            "provinceName": "Virginie",
            "provinceCode": "Virginia",
            "id": "VA"
        },
        {
            "provinceName": "Washington",
            "provinceCode": "Washington",
            "id": "WA"
        },
        {
            "provinceName": " Virginie-Occid'entale",
            "provinceCode": "West Virginia",
            "id": "WV"
        },
        {
            "provinceName": "Wisconsin",
            "provinceCode": "Wisconsin",
            "id": "WI"
        },
        {
            "provinceName": "Wyoming",
            "provinceCode": "Wyoming",
            "id": "WY"
        }
    ]
}